import { TNewbuildingComparisonStatus } from 'shared/types/newbuildingComparison';
import { actionGenerator } from 'shared/utils/redux/actionGenerator';

export enum ENewbuildingComparison {
  setStatus = 'newbuildingComparison/SET_STATUS',
}

export const setNewbuildingComparisonStatus = actionGenerator<
  ENewbuildingComparison.setStatus,
  TNewbuildingComparisonStatus | null
>(ENewbuildingComparison.setStatus);

export type TNewbuildingComparisonActions = ReturnType<typeof setNewbuildingComparisonStatus>;
